<template>
    <ve-loading :loading="processing">
        <div class="statistics">
            <div class="statistics-header">
                <div class="statistics-header-project">
                    <stats-header @change="onProjChange"></stats-header>
                </div>
                <div class="statistics-header-search" style="padding:0 20px;">
                    <searchbar 
                        :items="items" 
                        v-model="model" 
                        :show-button="false"/>
                </div>
            </div>
            <v-layout>
                <div class="statistics-charts">
                    <v-chart-card :title="chartsTitle"  :icon="chartsIcon" style="padding-bottom:20px;">
                        <el-radio-group v-model="dateType" slot="extra" @change="handleDateTypeChange">
                            <el-radio-button  :label="0">日</el-radio-button>
                            <el-radio-button :disabled="weekDisable" :label="1">周</el-radio-button>
                            <el-radio-button :disabled="monthDisable" :label="2">月</el-radio-button>
                        </el-radio-group>
                        <ve-skeleton :loading="loading" :title="{width: 60}" :paragraph="[{width: 20},{width: 40},{width: 60},{width: 80},{width: 90},{width: 80}, {width: 100}, {width: 80}]"  style="table-layout:fixed;">
                            <component :is="`ve-${chartType}`"
                                :data="chartData"
                                :width="width"
                                :setting="chartSetting"
                                :extend="chartExtend"
                                :data-zoom="chartData.rows && chartData.rows.length > 20 ? dataZoom : []"
                                :toolbox="toolbox">
                            </component>
                        </ve-skeleton>
                    </v-chart-card>
                </div>
                <div class="statistics-table">
                    <v-chart-card title="数据明细" :icon="tableIcon" :explain="explain">
                        <a v-if="exportUrl" slot="extra" :href="exportUrl"><span style="vertical-align:middle;color:#409bff;margin-right: 4px;">导出</span><Icon size="16" color="#409bff" style="vertical-align:middle;" type="ios-open-outline" /></a>
                        <ve-skeleton :loading="loading" :title="{width: 60}" :paragraph="[{width: 20},{width: 40},{width: 60},{width: 80},{width: 90},{width: 80}, {width: 100}, {width: 80}]" style="table-layout:fixed;">
                            <el-table ref="table" v-if="tableData && tableData.length" :data="tableData" stripe>
                                <el-table-column  v-for="item in tableTitle" show-overflow-tooltip :key="item.id" :width="item.width ? item.width: ''" header-align="center" :align="item.align ? item.align : 'center'" :fixed="item.fixed ? item.fixed : false" :prop="item.prop" :label="item.label"></el-table-column>
                            </el-table>
                        </ve-skeleton>
                    </v-chart-card>
                </div>
            </v-layout>
        </div>
    </ve-loading>
</template>

<script>
import { formatDate, getDistanceDays, getLastWeek } from '@/utils/date.js'
import chartsIcon from "@/assets/images/icon/stats-charts.png"
import tableIcon from "@/assets/images/icon/stats-table.png"
import VeLoading from './loading'
import line from './images/line.png'
import bar from './images/bar.png'
import download from './images/download.png'
import recover from './images/recover.png'
import stack from './images/stack.png'
export default {
    name: 'statistics',
    components: {
        VeLoading
    },
    props: {
        value: {
            type: Object,
            default () {
                return {}
            }
        },
        chartsTitle: {
            type: String,
            default: '趋势图'
        },
        items: {
            type: Array,
            default() {
                return []
            }
        },
        date: {
            type: Array,
            default() {
                return []
            }
        },
        chartSetting: {
            type: Object,
            default () {
                return {}
            }
        },
        explain: {
            type: String
        },
        chartExtend: {
            type: Object,
            default () {
                return {}
            }
        }
    },
    data () {
        return {
            processing: false,
            loading: true,
            oldDate: [],
            dateType: 0,
            chartType: 'line',
            chartData: {},
            model: {
                date: []
            },
            tableTitle: [],
            tableData: [],
            width: '',
            currentProj: {},
            weekDisable: true,
            monthDisable: true,
            exportUrl: '',
            chartsIcon,
            tableIcon,
            dataZoom: {          
                type: 'slider',
                start: 0,
                end: 100
            }
        }
    },
    computed: {
        toolbox () {
            return {
                itemSize: 20,
                feature: {
                    saveAsImage: {
                        name: this.chartsTitle,
                        icon: `image://${download}`,
                        backgroundColor: '#fff'
                    },
                    magicType: {
                        type: ['line', 'bar'],
                        icon: {
                            line: `image://${line}`,
                            bar: `image://${bar}`
                        }
                    },
                    restore: {
                        icon: `image://${recover}`
                    }
                },
                right: 20,
                showTitle: false,
                tooltip: { 
                    show: true,
                    trigger: 'item',
                    formatter: function (param) {
                        return '<div>' + param.title + '</div>'
                    },
                    backgroundColor: '#222',
                    textStyle: {
                        fontSize: 12,
                    },
                    extraCssText: 'box-shadow: 0 0 3px rgba(0, 0, 0, 0.3);',
                    position: 'bottom'
                }
            }
        }
    },
    watch: {
        value: {
            immediate: true,
            deep: true,
            handler (val) {
                if (val) this.model = val
            }
        },
        date: {
            deep: true,
            handler (old, val) {
                this.oldDate = val
                if (JSON.stringify(old) != JSON.stringify(val)) {
                    this.handleDateChange()
                }
            }
        },
        model: {
            deep: true,
            handler () {
                this.emitInput(this.model)
            }
        }
    },
    methods: {
        emitInput (value = {}) {
            this.$emit('input', value)
        },
        calculateDays (startDate, endDate) { //startDate和endDate是yyyy-MM-dd格式 
            let start = new Date(startDate)
            let end = new Date(endDate)
            let times = end.getTime() - start.getTime()
            let days = parseInt(times / (1000 * 60 * 60 * 24))
      　　  return days
        },
        onProjChange (project) {
            this.currentProj = project
            if (this.currentProj.id) {
                this.$emit('proj-change',{projId: this.currentProj.id,projName:this.currentProj.label})
            }
        },
        handleDateTypeChange () {
            this.$emit('search')
        },
        handleDateChange () {
            this.$nextTick(() => {
                let days = getDistanceDays(this.date[0], this.date[1])
                let type = -1
                if ( 7 < days && days <= 31) {
                    this.weekDisable = false
                    this.monthDisable = true
                    type = 1
                } else if (days > 31) {
                    this.weekDisable = false
                    this.monthDisable = false
                    type = 2
                } else {
                    this.weekDisable = true
                    this.monthDisable = true
                    type = 0
                }
                if (type !== this.dateType || this.oldDate != this.date) {
                    this.dateType = type
                    this.$emit('search')
                }
            })
        },
        select (api, req = {}) {
            if (this.processing) return
            if (!this.loading) this.processing = true
            if (this.date && this.date.length) {
                req = {
                    ...req,
                    startDate: this.date[0],
                    endDate: this.date[1]
                }
                delete req.date
            }
            req.type = this.dateType
            this.$api(api, req).then(res=> {
                this.chartType = res.chartType
                this.chartData = res.chartData
                this.tableTitle = res.tableTitle
                this.tableData = res.tableData
                this.exportUrl = res.url ? res.url : ''
                this.processing = false
                this.loading = false
                this.$nextTick(() => {
                    if (this.$refs.table) this.$refs.table.doLayout()
                })
            }).catch(err => {
                console.log(err)
                this.$tips(err,'error')
                this.processing = false
                this.loading = false
            })
        }
    },
    mounted() {
        this.width = '100%'
    }
}
</script>

<style lang="less" scoped>
    .statistics {
        &-header {
            background: #fff;
            border-radius: 4px;
            &-project {
                padding: 20px ;
            }
            &-search {
                background: #fff;
                border-radius: 4px;
            }
        }
        &-table {
            padding-bottom: 32px;
            background:#fff;
        }
    }
</style>



// WEBPACK FOOTER //
// src/components/statistics/statistics.vue